module.exports = __webpack_public_path__ + "static/img/4-3.b482f23.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/feature/face/4-3.png
// module id = sJyX
// module chunks = 1